import React, { useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import throttle from "lodash.throttle";
import { animateScroll } from "react-scroll";
import SpinnersLoading from "../../../../loader/SpinnersLoading";
import { getLivePaidEmdOfferForProduct } from "../../../../../redux/action/liveRoom";
import { initializeSocket } from "../../../../../helpers/SingletonSocketService";
import { globalContext } from "../../../../../context/ContextProvider";
import { getOrganizationDetails } from "../../../../../redux/action/organization";
import ProductLotsDetails from "../components/ProductLotsDetails";
import ProductLiveRoomHeader from "../liveRoomFrame/components/ProductLiveRoomHeader";
import ProductMobileLiveView from "../mobileView/ProductMobileLiveView";

function ProductLiveForLots() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, catalogueId } = useParams();
  const isDastop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  const [lotsNumber, setLotsNumber] = useState(1);
  const { profile } = useSelector((state) => state?.profileStore);
  const { ListLoadings, paidEmdOfferData, paidEmdLoading } = useSelector(
    (state) => state.liveAuctionList
  );
  const { setConnectingWithLiveRoom } = useContext(globalContext);
  const lotsContainerRef = useRef(null);
  const lotRefs = useRef({});

  const handleScroll = () => {
    Object.values(lotRefs.current).forEach((section, index) => {
      if (section) {
        const rect = section.getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight / 1.5) {
          setLotsNumber(index + 1);
        }
      }
    });
  };

  useEffect(() => {
    const throttledScroll = throttle(handleScroll, 200);
    window.addEventListener("scroll", throttledScroll);
    return () => {
      window.removeEventListener("scroll", throttledScroll);
    };
  }, []);

  const scrollToLot = (lotNumber) => {
    const targetLotElement = lotRefs.current[lotNumber];
    if (targetLotElement) {
      targetLotElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // setLotsNumber(lotNumber);
    }
  };

  useEffect(() => {
    dispatch(getLivePaidEmdOfferForProduct(id));
    dispatch(getOrganizationDetails());
  }, [dispatch, id]);

  useEffect(() => {
    if (paidEmdOfferData?.offers?.length && lotRefs.current[1]) {
      lotRefs.current[1].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setLotsNumber(1);
    }
    animateScroll.scrollToTop({ smooth: true });
  }, [paidEmdOfferData]);

  useEffect(() => {
    const socket = initializeSocket();

    socket.on("connect", () => {
      console.log("Connected to socket server");
      socket.emit("joinAuctionRoom", {
        organization: profile?.organization,
        auctionId: id,
      });
      setConnectingWithLiveRoom(false);
    });

    ["update-minimum-bid", "update-starting-price","update-offers-list", "timeExtended"].forEach(event => {
      socket.on(event, () => {
        dispatch(getLivePaidEmdOfferForProduct(id));
      });
    });

    socket.on("connect_error", (err) => {
      setConnectingWithLiveRoom(true);
      console.log(err);
    });

    const handleTabClose = () => {
      console.log("Disconnecting socket on tab close");
      socket.emit("leaveAuctionRoom", {
        organization: profile?.organization,
        auctionId: id,
      });
      socket.disconnect();
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      console.log("Disconnecting socket");
      socket.emit("leaveAuctionRoom", {
        organization: profile?.organization,
        auctionId: id,
      });
      socket.disconnect();
      setConnectingWithLiveRoom(true);
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, [id, setConnectingWithLiveRoom, profile, dispatch]);

  if (paidEmdLoading || ListLoadings) {
    return <SpinnersLoading />;
  }

  return (
    <>
      {isMobile ? (
        <ProductMobileLiveView paidEmdOfferData={paidEmdOfferData} />
      ) : (
        <div className="flex column gap-10px p-2">
          <span className={`valign-wrapper gap-1`}>
            <span
              className="material-icons-outlined pointer"
              onClick={() => navigate(-1)}
            >
              arrow_back
            </span>

            <h4>Live room</h4>
          </span>
          <div
            style={{ width: !isDastop && "80%", margin: !isDastop && "auto" }}
          >
            <div
              className="sticky-header flex gap-1 column"
              style={{
                position: "sticky",
                top: "0rem",
                zIndex: 1,
                background: "#f7f6f2",
                padding: "1rem 0rem",
              }}
            >
              <ProductLiveRoomHeader />
              <span>
                <div
                  className={`flex column gap-10px ${isDastop ? "mb-1" : "mb-2"
                    }`}
                >
                  <p className={`${isDastop ? "font-16px" : "font-18px"}`}>
                    Select the Lot number to navigate directly to the Lot.
                  </p>

                  <span style={{ marginLeft: "-10px" }}>
                    {Array.from(
                      { length: paidEmdOfferData?.offers?.length },
                      (_, i) => i + 1
                    ).map((page) => (
                      <button
                        key={page}
                        onClick={() => scrollToLot(page)}
                        className={`livelots-nativation ${page === lotsNumber && "cercle-purple white-text"
                          }`}
                      >
                        {page}
                      </button>
                    ))}
                  </span>
                </div>

                <button
                  className={`button-style pointer white-text font-16px`}
                  style={{
                    padding: "8px 10px",
                    width: "160px",
                    backgroundImage:
                      "linear-gradient(to right, #3C0A67 , #6F2DA8)",
                  }}
                  onClick={() =>
                    navigate(`/catalogue-live-room/${catalogueId}`)
                  }
                >
                  View Catalogue
                </button>
              </span>
            </div>

            <div
              ref={lotsContainerRef}
              className="flex column mt-4"
              style={{
                gap: "6rem",
              }}
            >
              {paidEmdOfferData?.offers?.map((item, index) => (
                <div
                  key={item.id || index}
                  ref={(el) => (lotRefs.current[index + 1] = el)}
                >
                  <ProductLotsDetails
                    liveOfferData={item}
                    index={index + 1}
                    singleAuctionData={paidEmdOfferData?.auction}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProductLiveForLots;
